import {
  MATCH_TYPE_INVOICE_DD_RETURN,
  MATCH_TYPE_INVOICE_FUNDS_TRANSFER,
  MATCH_TYPE_INVOICE_REPAYMENT,
} from '../match/constants'

export const REDUCER_KEY = 'invoices'
export const ACTION_KEY = 'invoices/FETCH'

const PRODUCT_TYPE_BF = 'BUYER_FINANCING'
const PRODUCT_TYPE_SF = 'SELLER_FINANCING'

export const productTypeMap = {
  [PRODUCT_TYPE_BF]: 'BF',
  [PRODUCT_TYPE_SF]: 'SF',
}

export const datePathMap = {
  [MATCH_TYPE_INVOICE_FUNDS_TRANSFER]: ['invoiceDate'],
  [MATCH_TYPE_INVOICE_REPAYMENT]: ['invoiceDueDate'],
  [MATCH_TYPE_INVOICE_DD_RETURN]: ['invoiceDueDate'],
}

export const dateTooltipMap = {
  [MATCH_TYPE_INVOICE_FUNDS_TRANSFER]: 'Invoice Creation Date',
  [MATCH_TYPE_INVOICE_REPAYMENT]: 'Invoice Due Date',
  [MATCH_TYPE_INVOICE_DD_RETURN]: 'Invoice Due Date',
}

export const openAmountPathMap = {
  [MATCH_TYPE_INVOICE_FUNDS_TRANSFER]: ['totals', 'fundsTransferOpenAmount'],
  [MATCH_TYPE_INVOICE_REPAYMENT]: ['totals', 'repaymentOpenAmount'],
  [MATCH_TYPE_INVOICE_DD_RETURN]: ['totals', 'repaymentOpenAmount'],
}

export const quickFilterOptions = [
  {
    label: 'All Entries',
    value: 'ALL_ENTRIES',
  },
  {
    label: 'Similar Open Amount',
    value: 'OPEN_AMOUNT',
  },
]
